import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "./Header";
import Tooltip from "../../../Components/common/Tooltip/Tooltip";
import Spinner from "../../../Components/common/Spinner/Spinner";
import Backdrop from "../../../Components/UI/Backdrop/Backdrop";

import {
  RequestGetUrlSettings,
  RequestSetUrlSettings,
  RequestToggleUrlSettings,
} from "../../../store/actions/mailGatewayActions";

const UrlSettingsForm = ({ selectedProduct, selectedHost }) => {
  const dispatch = useDispatch();

  const [settings, setSettings] = useState({
    url_settings_status: "",
    typo_control: "",
    malicious_control: "",
    unicode_control: "",
    download_control: "",
    ioc_control: "",
  });

  const urlSettings = useSelector((state) => state.mailGateway.urlSettings);
  const urlSettingsLoading = useSelector((state) => state.mailGateway.urlSettingsLoading);
  const setUrlSettingsLoading = useSelector((state) => state.mailGateway.setUrlSettingsLoading);

  const urlSettingsStatus = urlSettings.url_settings_status === "1";

  useEffect(() => {
    dispatch(RequestGetUrlSettings(selectedHost));
  }, [dispatch, selectedHost]);

  useEffect(() => {
    if (urlSettings && selectedHost) {
      setSettings((prevSettings) => ({
        ...prevSettings,
        ...urlSettings,
      }));
    }
  }, [urlSettings, selectedHost]);

  const toggleUrlSettingsHandler = () => {
    if (urlSettingsLoading) return;
    dispatch(
      RequestToggleUrlSettings({
        host: selectedHost,
        url_settings_status: urlSettingsStatus ? "0" : "1",
      }),
    );
  };

  const inputChangeHandler = (e) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const checkSaveButtonDisabled = () => {
    const keys = Object.keys(settings);
    for (const key of keys) {
      if (key === "url_settings_status") continue;
      else if (settings[key] !== urlSettings[key]) return false;
    }
    return true;
  };

  const saveHandler = () => {
    if (urlSettingsLoading || setUrlSettingsLoading) return;

    const { url_settings_status, ...subOptions } = settings;
    dispatch(RequestSetUrlSettings({ host: selectedHost, reqBody: subOptions }));
  };

  return (
    <>
      <Header
        selectedProduct={selectedProduct}
        selectedHost={selectedHost}
        toggleProps={{
          show: true,
          text: "Status",
          active: urlSettingsStatus,
          onClick: toggleUrlSettingsHandler,
        }}
      />
      <form className="products-body-form">
        <div className="products-body-form__line">
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Typosquat Control
              <Tooltip text={"If enabled, typo check will be performed."} />
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="typo_control"
                  checked={settings.typo_control === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="typo_control"
                  checked={settings.typo_control === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Malicious Control
              <Tooltip text={"If enabled, malicious check will be performed."} />
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="malicious_control"
                  checked={settings.malicious_control === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="malicious_control"
                  checked={settings.malicious_control === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Unicode Control
              <Tooltip text={"If enabled, unicode check will be performed."} />
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="unicode_control"
                  checked={settings.unicode_control === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="unicode_control"
                  checked={settings.unicode_control === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
        </div>

        <div className="products-body-form__line" style={{ gap: "50px", marginBottom: "8px" }}>
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Download Control
              <Tooltip
                text={"If enabled, it will be checked whether the url is a download link."}
              />
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="download_control"
                  checked={settings.download_control === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="download_control"
                  checked={settings.download_control === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              IOC Control
              <Tooltip text={"If enabled, ioc control with instance data will be performed."} />
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="ioc_control"
                  checked={settings.ioc_control === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="ioc_control"
                  checked={settings.ioc_control === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
        </div>
        <br/>

        <button
          type="button"
          className="save-button primary-button"
          onClick={saveHandler}
          disabled={checkSaveButtonDisabled()}>
          {urlSettingsLoading || setUrlSettingsLoading ? (
            <Spinner width={12} height={12} />
          ) : (
            "Save Settings"
          )}
        </button>

        <Backdrop
          spinner={false}
          absolute
          show={!urlSettingsStatus}
          message="Url settings are inactive! Please click on the status button at the header to activate url settings."
          messageStyle={{ paddingTop: 0 }}
        />
      </form>
    </>
  );
};

export default UrlSettingsForm;
